/* Weidelandfarm — Kategoriefilter im Hofladen-Abschnitt.
   Filtert die bereits geladenen Karten im Browser; ohne JavaScript bleiben alle sichtbar. */
(function () {
  function einrichten(bereich) {
    var knoepfe = bereich.querySelectorAll('[data-wlf-filter]');
    var karten = bereich.querySelectorAll('[data-wlf-kategorie]');
    var leer = bereich.querySelector('[data-wlf-leer]');
    if (!knoepfe.length || !karten.length) return;

    function filtern(wunsch) {
      var sichtbar = 0;
      karten.forEach(function (karte) {
        var passt = !wunsch || wunsch === 'alle' || karte.dataset.wlfKategorie === wunsch;
        karte.hidden = !passt;
        if (passt) sichtbar++;
      });
      if (leer) leer.hidden = sichtbar > 0;
    }

    knoepfe.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        knoepfe.forEach(function (k) {
          k.classList.toggle('wlf-kat--aktiv', k === knopf);
          k.setAttribute('aria-pressed', k === knopf ? 'true' : 'false');
        });
        filtern(knopf.dataset.wlfFilter || 'alle');
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-wlf-shop]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
